import script from "./ProjectCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCreate.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCreate.vue?vue&type=style&index=0&id=39437466&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39437466"]])

export default __exports__